/** "New queue": a name, instructions, the scores to ask and whom to share it with. It starts empty. */

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/overlay";
import { errorText } from "@/components/ui/states";
import { useUiStore } from "@/stores/ui-store";
import { useCreateQueue } from "./hooks";
import { QueueFields, draftReady, emptyDraft, toCreate } from "./queue-fields";

export function NewQueueDialog({ onClose }: { onClose: () => void }) {
  const [draft, setDraft] = useState(emptyDraft);
  const create = useCreateQueue();
  const notify = useUiStore((s) => s.notify);
  const submit = () =>
    create.mutate(toCreate(draft), {
      onSuccess: (q) => (notify(`Created ${q.name}.`), onClose()),
      onError: (e) => notify(errorText(e, "Could not create the queue."), "error"),
    });

  return (
    <Dialog
      title="New queue"
      subtitle="Reviewers answer these scores for every item in the queue."
      onClose={onClose}
      width={620}
      footer={
        <>
          <span className="flex-1" />
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" disabled={!draftReady(draft) || create.isPending} onClick={submit}>
            Create queue
          </Button>
        </>
      }
    >
      <QueueFields draft={draft} onChange={(patch) => setDraft((d) => ({ ...d, ...patch }))} />
    </Dialog>
  );
}
